import Header from '@/layouts/hydrogen/header';
import Sidebar from '@/layouts/hydrogen/sidebar';
import { PageTitleProvider } from '@/layouts/hydrogen/page-title';

export default function HydrogenLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PageTitleProvider>
    <main className="flex min-h-screen flex-grow">
      <Sidebar className="fixed hidden dark:bg-gray-50 xl:block" />
      <div className="flex w-full flex-col xl:ms-[270px] xl:w-[calc(100%-270px)] 2xl:ms-72 2xl:w-[calc(100%-288px)]">
        <Header />
        {/* `[&>*]:grow`: the page fills the column, so a short form's Cancel/Submit bar can sit at
            the bottom of the screen (apps/admin lib/form-layout.ts). Non-mechanical edit. */}
        <div className="flex flex-grow flex-col px-4 pb-6 pt-2 md:px-5 lg:px-6 lg:pb-8 3xl:px-8 3xl:pt-4 4xl:px-10 4xl:pb-9 [&>*]:grow">
          {children}
        </div>
      </div>
    </main>
    </PageTitleProvider>
  );
}
